module.exports = __webpack_public_path__ + "svg/libra.svg?9e472bd95f918f2662839784b1ed4b20";